<mat-card>
  <mat-card-header>
    <mat-card-title>Aplicaciones</mat-card-title>
    <mat-card-subtitle>Consulta y sigue el estado de tus solicitudes de emisión</mat-card-subtitle>
  </mat-card-header>
  <mat-card-actions align="end">
    <button mat-button (click)="reloadSearch(undefined)" matTooltip="Recargar">
      <mat-icon>refresh</mat-icon>
    </button>
    <button mat-raised-button color="primary" (click)="createApplication()"
            matTooltip="Crear aplicación">Iniciar presolicitud de emisión
    </button>
  </mat-card-actions>
  <mat-card-content>

    <div class="mat-elevation-z8">
      @if (dataSource.isLoadingResults()) {
        <div class="example-loading-shade">
          @if (dataSource.isLoadingResults()) {
            <mat-spinner></mat-spinner>
          }
        </div>
      }
      <app-applications-search (updated)="reloadSearch($event)"></app-applications-search>
      <table mat-table class="applications-table" matSort matSortActive="status" matSortDisableClear
             matSortDirection="desc">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> ID</th>
          <td mat-cell *matCellDef="let element">
            @if (element.status === 'NEW' || element.status === 'IN_PROGRESS') {
              <a matButton="elevated" [routerLink]="['/application-update/'+element.id]">
                {{ element.id | slice : 25 }}
              </a>
            } @else {
              <a matButton="elevated" [routerLink]="['/application-detail/'+element.id]">
                {{ element.id | slice : 25 }}
              </a>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="personName">
          <th mat-header-cell *matHeaderCellDef> Nombre Asegurado</th>
          <td mat-cell *matCellDef="let element"> {{ element.insured.fullName }}</td>
        </ng-container>
        <ng-container matColumnDef="personIdentifier">
          <th mat-header-cell *matHeaderCellDef> Documento Asegurado</th>
          <td mat-cell *matCellDef="let element"> {{ element.insured.identificationNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="insuredInterestIdentifier">
          <th mat-header-cell *matHeaderCellDef> ID Riesgo</th>
          <td mat-cell *matCellDef="let element"> {{ element.insurableInterestIdentifier }}</td>
        </ng-container>
        <ng-container matColumnDef="quotationIdentifier">
          <th mat-header-cell *matHeaderCellDef> Cotización</th>
          <td mat-cell *matCellDef="let element"> {{ element.quotationIdentifier }}</td>
        </ng-container>
        <ng-container matColumnDef="inspectionIdentifier">
          <th mat-header-cell *matHeaderCellDef> Inspección</th>
          <td mat-cell *matCellDef="let element"> {{ element.inspectionIdentifier }}</td>
        </ng-container>
        <ng-container matColumnDef="companyName">
          <th mat-header-cell *matHeaderCellDef> Compañía</th>
          <td mat-cell *matCellDef="let element"> {{
              insurers.get(element.insurer.id)?.description
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Estado</th>
          <td mat-cell *matCellDef="let element"> {{ statusEnumLookup[element.status] }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let element">
            <div class="application-actions">
              <button mat-icon-button class="menu-button"
                      [routerLink]="['/application-documents/'+element.id]" matTooltip="Documentos">
                <mat-icon>folder_open</mat-icon>
              </button>
              <button mat-icon-button class="menu-button" (click)="onMessagesClicked(element.id)"
                      matTooltip="Mensajes">
                <mat-icon>comment_bank</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No hay aplicaciones</td>
        </tr>
      </table>
      <mat-paginator [length]="dataSource.resultsLength()" [pageSize]="20"
                     [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                     aria-label="Páginas">
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
